import React from 'react'

import Base from '../_Base'

const Universal12 = (props) => (
  <Base width="38" height="22" viewBox="0 0 38 22" fill="none" {...props}>
    <path
      d="M3.701 1.642A2 2 0 0 1 5.67 0h29.935a2 2 0 0 1 1.967 2.358l-3.272 18A2 2 0 0 1 32.33 22H2.396A2 2 0 0 1 .43 19.642l3.272-18Z"
      fill="#4A4E58"
      fillOpacity=".7"
    />
    <path
      d="M13.18 6.818 11.488 17H9.644l1.392-8.387h-.06l-2.634 1.521.278-1.69 2.804-1.626h1.755ZM14.074 17l.224-1.332 4.106-3.466c.395-.341.726-.644.995-.91.271-.268.485-.525.641-.77.156-.249.257-.514.303-.795.053-.322.027-.599-.08-.83a1.112 1.112 0 0 0-.506-.533c-.23-.126-.506-.189-.83-.189-.335 0-.642.07-.92.21-.279.135-.51.33-.697.586-.182.252-.301.55-.357.895h-1.755a3.605 3.605 0 0 1 .726-1.686c.377-.477.85-.846 1.416-1.108a4.379 4.379 0 0 1 1.86-.393c.683 0 1.26.128 1.73.383.474.255.815.605 1.024 1.049.212.444.27.951.174 1.521a3.477 3.477 0 0 1-.413 1.124c-.205.364-.528.772-.97 1.223-.44.447-1.043.989-1.809 1.625l-2.043 1.785-.015.07h4.43L21.054 17h-6.98ZM26.07 15.36l1.134-6.881h1.566l-1.138 6.88H26.07Zm-2.227-2.66.264-1.557h6.88l-.263 1.557h-6.88Z"
      fill="#BBB"
    />
  </Base>
)

export default Universal12
